import { useSubscriptionsStore } from "@/stores/subscriptions";

export async function hasLegacyWebroot(): Promise<boolean> {
  const subscriptionsStore = useSubscriptionsStore();
  await subscriptionsStore.populateSubscriptions();
  const subscriptions = subscriptionsStore.subscriptions;
  return subscriptions && subscriptions.length > 0 && subscriptions.some(s => s.isLegacyWebroot);
}
